import { BookmarkModel } from 'src/app/bookmarks/models/bookmark.model';
import { ScreenDimensions } from 'src/app/shared/models/screen.dimensions.model';
import { ColorModel } from 'src/app/edit/models/color.model';
import { CameraModel } from 'src/app/engine/models/camera.model';
import { WidgetOptions } from '../models/widget-options.model';

export class SetPublishWidgetURL {
  static readonly type = '[Publish] Set Widget URL';
  constructor(public widgetURL: string) { }
}

export class SetPublishDimensions {
  static readonly type = '[Publish] Set Dimensions';
  constructor(public dimensions: ScreenDimensions) { }
}

export class SetPublishBackgroundColor {
  static readonly type = '[Publish] Set Background Color';
  constructor(public color: ColorModel) { }
}

export class GetPublishIFrame {
  static readonly type = '[Publish] Get iFrame';
  constructor(
    public model: BookmarkModel,
    public widgetOptions?: WidgetOptions,
    public camera?: CameraModel
  ) { }
}

export class GetPublishIFrameSuccess {
  static readonly type = '[Publish] Get iFrame Success';
  constructor(public embed: string) { }
}

export class GetPublishIFrameFail {
  static readonly type = '[Publish] Get iFrame Fail';
  constructor() { }
}

export class GetPublishURL {
  static readonly type = '[Publish] Get URL';
  constructor(
    public model: BookmarkModel,
    public widgetOptions?: WidgetOptions,
    public camera?: CameraModel
  ) { }
}

export class GetPublishURLSuccess {
  static readonly type = '[Publish] Get URL Success';
  constructor(public model: BookmarkModel, public url: string) { }
}

export class GetPublishURLFail {
  static readonly type = '[Publish] Get URL Fail';
  constructor(public model: BookmarkModel) { }
}

export class SetPublishing {
  static readonly type = '[Publish] Set Publishing';
  constructor(public publishing: boolean) { }
}

export class ResetPublish {
  static readonly type = '[Publish] Reset Publishing';
  constructor() { }
}

export class SavePublishImage {
  static readonly type = '[Publish] Save Publish Image';
  constructor(public imageData: string) { }
}

export class SavePublishImageSuccess {
  static readonly type = '[Publish] Save Publish Image Success';
  constructor(public imageURL: string) { }
}

export class SavePublishImageFail {
  static readonly type = '[Publish] Save Publish Image Fail';
  constructor() { }
}

export class GetPublishImageCode {
  static readonly type = '[Publish] Get Publish Image Code';
  constructor(
    public model: BookmarkModel,
    public imageData: string,
    public widgetOptions?: WidgetOptions,
    public camera?: CameraModel    
  ) { }
}

export class GetPublishImageCodeSuccess {
  static readonly type = '[Publish] Get Publish Image Code Success';
  constructor(public embed: string) { }
}

export class GetPublishImageCodeFail {
  static readonly type = '[Publish] Get Publish Image Code Fail';
  constructor() { }
}
